exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StudentsPage{width:95%}.StudentsPage .question-container{max-width:1120px;margin:0}.StudentsPage .question-types-block{display:flex;flex-direction:column}.StudentsPage .btn-actions{display:flex}.StudentsPage .table-data{margin-top:20px}.StudentsPage .table-data .actions{color:#00adff}.StudentsPage .table-data .actions .far{margin-right:10px;cursor:pointer}.StudentsPage .table-data .actions .anticon+.anticon{margin-left:10px}.StudentsPage .table-data .actions .anticon{cursor:pointer}.Modal-student-profile{display:flex;flex-direction:row}.Modal-student-profile .col1{padding-right:20px}.Modal-student-profile .col1 .avatar{width:120px;height:120px;background:grey}.Modal-student-profile .col2{width:100%}.Modal-student-profile .col2 .field{margin-bottom:20px;font-size:18px}.Modal-student-profile .col2 .field label{font-size:18px;color:#a8a8a8;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Students/style.scss
// module id = 4985
// module chunks = 0